module.exports = __webpack_public_path__ + "img/fin-agent-edit-auto-ask-dark.a5d0220.svg";